import React, { AudioHTMLAttributes, useEffect, useRef } from 'react'

type PropsType = AudioHTMLAttributes<HTMLAudioElement> & {
    srcObject?: MediaStream | null
    sinkId: string
}

// courtesy:
// https://github.com/facebook/react/issues/11163 @tjmehta
export default function Audio({ srcObject, sinkId, ...props }: PropsType) {
    const refAudio = useRef<HTMLAudioElement>(null)

    useEffect(() => {
        const f = async () => {
            if (!refAudio.current) {
                return
            }

            console.log(`Audio: setting refAudio.current.srcObject=%O.`, srcObject)
            refAudio.current.srcObject = srcObject || null

            console.log(`Audio: calling setSinkId(${sinkId}).`)
            if (sinkId != null) {
                // set to default, then set the sinkId. Courtesy to
                //   <github.com/nwjs/nw.js/issues/4340>

                try {
                    if (sinkId === 'default' || sinkId === '_default') {
                        console.log(`Audio: Setting setSinkId='' for system default.`)
                        // @ts-ignore
                        refAudio.current.setSinkId('')
                        return
                    }
                    console.log(`Audio: Setting setSinkId=default as preflight.`)
                    // @ts-ignore
                    await refAudio.current.setSinkId('default')
                    console.log(`Audio: Setting setSinkId=default success.`)

                    console.log(`Audio: Setting setSinkId=${sinkId}.`)

                    refAudio.current
                        // @ts-ignore
                        .setSinkId(sinkId)
                        .then(() => {
                            console.log(`Audio: Success, audio sinkId=${sinkId}.`)
                        })
                        .catch((e: any) => {
                            console.error(`Audio: Failed to setSinkId for sinkId=${sinkId}.`)
                            console.error(e)
                        })
                } catch (e) {
                    let errorMessage = e
                    if ((e as any)?.name === 'SecurityError') {
                        errorMessage = `You need to use HTTPS for selecting audio output device: ${e}`
                    } else {
                        console.error(`Audio: Failed to setSinkId for sinkId=${sinkId}.`)
                        console.error(errorMessage)
                    }
                }
            }
        }
        f()
    }, [sinkId, srcObject, refAudio.current])

    return <audio ref={refAudio} {...props} />
}
